export const getAccessorieName = (prodName: string) => {
    if (prodName.includes('Felt')) {
        return prodName;
    } else if (prodName.includes('Arms')) {
        return prodName.split(',')[0].split(' - ')[1];
    } else if (prodName.includes('Cleaning Cloth')) {
        var name = prodName.split(',')[0].split(' - ')[1];
        if (!name.includes('Cleaning Cloths')) {
            name = 'Cleaning Cloths - ' + name;
        }
        return name;
    } else if (prodName.includes('Pin Garage')) {
        return prodName;
    } else if (prodName.includes('Spex Glasses')) {
        return prodName;
    } else if (prodName.includes('Flex Accessory Clip')) {
        return prodName;
    } else if (prodName.includes('Glasses Straps')) {
        return prodName;
    }

    return prodName.split(',')[0].split(' - ')[0];
}

const productNameMapper: Record<string, string> = {
    'Lens Cleaner Spray / 60 ml - White': 'Lens Cleaner Spray / 60 ml'
}

export const getProductName = (productName: string) => {

    if (productNameMapper[productName] == null) {
        return productName;
    }

    return productNameMapper[productName];
}